import { h, Component } from 'preact';
import Icon from '../icon/icon';
import styles from './header.css';

export default class Header extends Component {
  state = {
    open: false
  }

  close = () => {
    this.setState({
      open: false
    });
  }

  toggleOpen = () => {
    this.setState({
      open: !this.state.open
    });
  }

  renderItems = () => {
    if (this.props.homeOnly) {
      return ( <ul className={styles.menu}>
        <li className={styles.menuItem}>
          <a href="/" className={styles.menuLink} onClick={this.close}>Home</a>
        </li>
      </ul>);
    }

    return (<ul className={styles.menu}>
      <li className={styles.menuItem}>
        <a href="#page-about" className={styles.menuLink} onClick={this.close}>About Us</a>
      </li>
      <li className={styles.menuItem}>
        <a href="#page-products" className={styles.menuLink} onClick={this.close}>Products</a>
      </li>
      <li className={styles.menuItem}>
        <a href="#page-contact" className={styles.menuLink} onClick={this.close}>Contact</a>
      </li>
      <li className={`${styles.menuItem} ${styles.socialItem}`}>
        <a href="https://www.facebook.com/TroubleBrewingSingapore/" target="_blank" rel="noopener noreferrer"><img className={styles.social} src="/assets/facebookCircle.png" /></a>
      </li>
      <li className={`${styles.menuItem} ${styles.socialItem}`}>
        <a href="https://www.instagram.com/troublebrewingsg/" target="_blank" rel="noopener noreferrer"><img className={styles.social} src="/assets/instagramCircle.png" /></a>
      </li>
    </ul>);
  }

  render() {
    const { open } = this.state;

    return (
      <header className={styles.container}>
        <div className={styles.inner}>
          <div className={styles.title}>
            <h1>Trouble Brewing</h1>
            <a href="/"><img className={styles.logo} src="/assets/logo.png" alt="Trouble Brewing" /></a>
          </div>
          <button className={`clearButton ${styles.openNav}`} onClick={this.toggleOpen}>
            <Icon glyph="menu" />
          </button>
          {open && <div className={styles.overlay} onClick={this.close} />}
          <nav className={`${styles.navigation} ${open ? styles.navigationOpen : ''}`}>
            <button className={`clearButton ${styles.closeNav}`} onClick={this.toggleOpen}>
              <Icon glyph="close" />
            </button>
            {this.renderItems()}
          </nav>
        </div>
      </header>
    );
  }
}



// WEBPACK FOOTER //
// ./components/header/header.jsx